<ng-container>
  <!-- <div class="toolbar-container"> -->
    <ng-container *ngIf="(isBloomConfigLoading || hasPermission || isLoginRequired || isLandingPageLogin)">
        <app-bloom-toolbar [ngClass]="{'floating-toolbar': bloomMeta?.settings?.is_floating_toolbar}"
        [bloomMeta]="bloomMeta"
        [pages]="pages"
        [currentBloomCode]="currentBloomCode"
        [isLoggedIn]="isLoggedIn"
        [version]="version"
        (bloomLogin)="bloomLogin()"
        (bloomLogout)="bloomLogout()"
        (pageChange)="hideFooter($event)"
        (previewPageChange)="previewPageChange($event)"
        (openSettings)=" allowSettingsChange()"
        (toggleSidenavEvent)="toggleSidenav()"
        [activePageCode]="pageService.currentPageCode.value"
      > </app-bloom-toolbar>
    </ng-container>
  <!-- </div> -->
  <spinner [center]="true"  [selfSpin]="spinner" size="la-2x" color="grey" type="ball-triangle-path"></spinner>
  <ng-container  *ngIf="bloomMeta && (hasPermission || isLoginRequired || isLandingPageLogin)"
 >
    <mat-sidenav-container class="main-container" *ngIf="ready && !isSettingsOpen && bloomMeta?.settings?.menu_display_type === 'sidebar'">
      <mat-sidenav #sidenav [mode]="(innerWidth < 960) ? 'over' : 'side'" [opened]="sidenavOpen" [fixedInViewport]="innerWidth < 960" class="bloom-sidenav">
        <div class="sidenav-content">
          <mat-nav-list>
            <ng-container *ngFor="let page of pages; trackBy: trackByFn">
              <div  class="page-level">
              <div fxLayout="row"  class="page-entry"  fxLayoutAlign="start center">
                <div fxFlex="none" >
                  <button *ngIf="page.children?.pages?.length" 
                  mat-icon-button
                  class="compact-icon-button"
                  (click)="page.expanded = !page.expanded;$event.stopPropagation()">
                  <mat-icon>{{ page.expanded ? 'expand_less' : 'chevron_right' }}</mat-icon>
                  </button>
                </div>
                
                <div fxFlex="none" [ngClass]="page.code == pageService?.currentPageCode?.value ? 'active-page' : ''" >
                <a fxFlex [ngClass]="page.children?.pages?.length ? 'sub-page-button-padding' : ''" 
                  *ngIf="!metaService.isBloomPreview" 
                  (click)="pageChangeDetected($event);$event.stopPropagation()"
                  [routerLink]="['/p/' + currentBloomCode + '/' + page.code]"
                  [queryParams]="version === 'latest' ? '' : version !=='latest' ? {v: version} : ''"
                >
                 {{ page.name }}
                </a>
                <a  *ngIf="metaService.isBloomPreview" 
                  [ngClass]="page.code == pageService?.currentPageCode?.value ? 'active-page' : ''" 
                 (click)="handlePageClick(page);$event.stopPropagation()">
                  {{ page.name }}
                 </a>
                </div>
              </div>
              
              <app-hierarchical-page-menu
                *ngIf="page.expanded && page.children?.pages?.length"
                [pageMap]="page.children"
                [pages]="page.children.pages"
                [activePageCode]="pageService.currentPageCode.value"
                (pageSelected)="handlePageSubClick($event, metaService.isBloomPreview);$event.stopPropagation()"
                [level]="2"
              >
              </app-hierarchical-page-menu>
              </div>
            </ng-container>
          </mat-nav-list>
        </div>
      </mat-sidenav>
      <mat-sidenav-content [ngClass]="{'content-with-sidenav': sidenavOpen && innerWidth >= 960}">
        <div>
          <router-outlet *ngIf="type != 'internal'"  (activate)="onActivate($event)"></router-outlet>
          <app-page *ngIf="type == 'internal'" [changedPageCode]="changedPageCode" [changedPagePath]="changedPagePath" [_builderMode]="false"></app-page>
          <div class="footer-view" *ngIf="showFooter || type === 'internal'">
            <mat-divider></mat-divider>
            <app-page [footerConfig]="{ 'isFooterPage': true, 'changeContext': false }" [_builderMode]="false"></app-page>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    
    
    <div *ngIf="ready && !isSettingsOpen && bloomMeta?.settings?.menu_display_type !== 'sidebar'"
      [ngClass]="{'floating-toolbar-container': bloomMeta?.settings?.is_floating_toolbar}">
      <router-outlet *ngIf="type != 'internal'"  (activate)="onActivate($event)"></router-outlet>
      <app-page *ngIf="type == 'internal'" [changedPageCode]="changedPageCode" [changedPagePath]="changedPagePath" [_builderMode]="false"></app-page>
      <div class="footer-view" *ngIf="showFooter || type === 'internal'">
        <mat-divider></mat-divider>
        <app-page [footerConfig]="{ 'isFooterPage': true, 'changeContext': false }" [_builderMode]="false"></app-page>
      </div>
    </div>


    <div *ngIf="isLoginRequired">
      <app-bloom-login [isDialog]="" (loggedIn)="loggedIn($event)" ></app-bloom-login>
    </div>

    <div *ngIf="isSettingsOpen && !ready">
      <app-settings></app-settings>
    </div>

    <!-- <app-page *ngIf="!pageCodeExists"></app-page> -->

    <div *ngIf="terminationError" class="terminationError">
      Requested URL is invalid. (Bloom code not present)
    </div>
    <div *ngIf="versionError" class="versionError">
      Requested URL is invalid. (Invalid version given)
    </div>
  </ng-container>
</ng-container>
